module.exports = __webpack_public_path__ + "static/media/home-marina.464bcf5a.svg";